var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(8 8)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19V15.002C21 14.7367 20.8946 14.4824 20.7071 14.2948C20.5195 14.1073 20.2652 14.002 20 14.002C19.7347 14.002 19.4804 14.1073 19.2928 14.2948C19.1053 14.4824 19 14.7367 19 15.002V19H15.002C14.7367 19 14.4824 19.1053 14.2948 19.2928C14.1073 19.4804 14.002 19.7347 14.002 20C14.002 20.2652 14.1073 20.5195 14.2948 20.7071C14.4824 20.8946 14.7367 21 15.002 21H19V24.998C19 25.2632 19.1053 25.5175 19.2928 25.7051C19.4804 25.8926 19.7347 25.998 20 25.998C20.2652 25.998 20.5195 25.8926 20.7071 25.7051C20.8946 25.5175 21 25.2632 21 24.998V21H24.998C25.2632 21 25.5175 20.8946 25.7051 20.7071C25.8926 20.5195 25.998 20.2652 25.998 20C25.998 19.7347 25.8926 19.4804 25.7051 19.2928C25.5175 19.1053 25.2632 19 24.998 19H21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProduct);
export default __webpack_public_path__ + "static/media/addProduct.41a014f7e561c6e9a2acfac931d25cd9.svg";
export { ForwardRef as ReactComponent };